<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'mouseenter'): void;
  (event: 'mouseleave'): void;
  (event: 'focus'): void;
  (event: 'blur'): void;
  (event: 'update:value', value: number | null): void;
  (event: 'reset', value: number | null): void;
  (event: 'minimize', value: number): void;
  (event: 'maximize', value: number): void;
  (event: 'decrease', value: number, steps: number): void;
  (event: 'increase', value: number, steps: number): void;
}>();

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    value?: number | undefined;
    default?: number;
    min?: number;
    max?: number;
    step?: number;
    showReset?: boolean;
  }>(),
  {
    disabled: false,
    value: undefined,
    default: 0,
    min: 0,
    max: 50,
    step: 5,
    showReset: true,
  },
);
</script>

<template>
  <tw-ui-slider
    ref="slider"
    :disabled="props.disabled"
    :max="props.max"
    :min="props.min"
    :step="props.step"
    :value="props.value"
    :show-reset="props.showReset"
    class="filter--radius"
    @blur="emit('blur')"
    @decrease="emit('decrease', $event, $event / props.step)"
    @focus="emit('focus')"
    @increase="emit('increase', $event, $event / props.step)"
    @maximize="emit('maximize', $event)"
    @minimize="emit('minimize', $event)"
    @mouseenter="emit('mouseenter')"
    @mouseleave="emit('mouseleave')"
    @reset="emit('reset', $event)"
    @update:value="emit('update:value', $event)"
  />
</template>

<style lang="scss" scoped>
.tw-slider {
}
</style>
